import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import CustomInput from 'component/Input/CustomInputDark';
import CustomInputText from 'component/Input/CustomInputDarkText';
import { addCrypto, addMoreCrypto, getCryptoById } from 'api/crypto';
import { useDispatch } from 'react-redux';
import { set_message } from 'redux/reducer/message';
import FormateCurrency from 'utils/FormateCurrency';
import { fireCoinConfetti } from 'utils/fireCoinConfetti';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 410,
    width:'90%',
    margin:'auto',
    bgcolor: 'primary.light',
    border: '1px solid #000',
    boxShadow: 24,
    color: 'common.white',
    p: 1.8,
    borderRadius: 3,
    marginBottom: 50,
};





export default function AddMoreCrypto({refresh, visible, setVisble,id,symbol }) {
    const [open, setOpen] = React.useState(visible);
    const [data, setData] = React.useState({new_avg_buy:'',qty:''});
    const [key,setkey]=React.useState(0);
    const dispatch=useDispatch();
    React.useEffect(()=>{
        getCryptoById(id)
        .then(res=>setData({...res.data,qty:'',current_qty:res.data.qty}))
        .catch(err=>console.log(err))
    },[])
    React.useEffect(() => {
        if(visible){
            setkey(Math.random())
        }
        setOpen(visible);
    }, [visible]);

    const handleClose = () => {
        setOpen(false);
        setVisble(null);
    }

    const handleChange = (e) => {
        setData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    }

    const hasPositiveNumber = (value) => {
        const parsed = parseFloat(value);
        return value !== '' && value != null && Number.isFinite(parsed) && parsed > 0;
    };

    const canSave = React.useMemo(() => (
        hasPositiveNumber(data.qty) && hasPositiveNumber(data.new_avg_buy)
    ), [data.qty, data.new_avg_buy]);

    const saveButtonSx = {
        color: '#fff',
        borderColor: '#fff',
        borderRadius: '20px',
        textTransform: 'capitalize',
        '&.Mui-disabled': {
            color: 'rgba(255,255,255,0.35)',
            borderColor: 'rgba(255,255,255,0.25)',
        },
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!canSave) return;
        data.symbol=symbol;
        addMoreCrypto(id,data)
        .then(res=>{
            fireCoinConfetti();
            dispatch(set_message(`updated info for ${symbol}`))
            refresh();
            handleClose();
        })
        .catch(err=>console.log(err))
    }

    return (
        <Box 
        key={key}
        >
        <Modal
            keepMounted
            open={open}
            onClose={handleClose}
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
        >
            <Box component='form' onSubmit={handleSubmit} sx={style}>
                <IconButton
                    type="button"
                    onClick={handleClose}
                    aria-label="Close add more coin modal"
                    sx={{
                        position: 'absolute',
                        top: 8,
                        right: 8,
                        zIndex: 1,
                        color: '#fff',
                        p: 0.5,
                        '&:hover': { bgcolor: 'transparent', opacity: 0.75 },
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <Box sx={{ marginBottom: 4, marginTop: 2, textAlign: 'center' }}>
                <img src={`https://lcw.nyc3.cdn.digitaloceanspaces.com/production/currencies/64/${symbol.toLowerCase()}.png`}/><br/><br/>
                    <Typography id="keep-mounted-modal-title" variant="h6" component="h2">
                        Add More  {symbol?.replaceAll('_','')}
                    </Typography>
                </Box>
                <Box>
                    <Typography>
                        Current Quantity : {data.current_qty||"..."}
                    </Typography>
                    <Typography>
                        Avg. Buy : {data.avg_buy?FormateCurrency(data.avg_buy):"..."}
                    </Typography>
                </Box>
                <Box>
                     <CustomInput  onChange={handleChange} type='text' inputMode="numeric"  value={data.qty} name='qty' sx={{ mt: 2 }} label='Quantity' />
                     <CustomInput  onChange={handleChange} type='text' inputMode="numeric" value={data.new_avg_buy} name='new_avg_buy' sx={{ mt: 2 }} label='Purchase Price' />
                     <CustomInputText value={data.notes} onChange={handleChange} type="text" name='notes' sx={{ mt: 2 }} label='Notes' optional />
                </Box>
                <Box sx={{ width: '100%', height: 1.1, background: '#fff', marginTop: 3 }} />
                <Box sx={{ paddingTop: 3, display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        type='submit'
                        disabled={!canSave}
                        sx={saveButtonSx}
                        variant="outlined"
                    >
                        Save
                    </Button>
                </Box>
            </Box>
        </Modal>
        </Box>
    );
}


